/**
 * Firebase configuration for PAX application
 * PRODUCTION Firebase Auth - sole authentication method
 * 
 * Firebase Web SDK v11.10.0 (modular v9+)
 * NO Analytics - not required for auth
 */
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // NO measurementId - Analytics not used
};

// Validate required config for production Firebase auth
const validateConfig = () => {
  const required = ['apiKey', 'authDomain', 'projectId', 'appId'];
  const missing = required.filter(key => !firebaseConfig[key]);
  
  if (missing.length > 0) {
    console.error(`[Firebase] CRITICAL: Missing required config: ${missing.join(', ')}`);
    return false;
  }
  return true;
};

// Initialize Firebase
let app = null;
let auth = null;
let isConfigValid = false;

if (validateConfig()) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    isConfigValid = true;
    console.log('[Firebase] Initialized successfully');
  } catch (error) {
    console.error('[Firebase] Initialization failed:', error);
  }
} else {
  console.error('[Firebase] Configuration invalid - auth will not work');
}

export { app, auth };
export const isFirebaseConfigured = () => isConfigValid && !!auth;
